import React from 'react';
import { Box, Fade, IconButton, Typography } from '@mui/material';
import { Delete as DeleteIcon, Description as FileIcon } from '@mui/icons-material';
// helpers
import { formatFileSize } from 'lib/helper';
// constants, styles, interfaces
import { CSV_FILE_TEXT, UPLOAD_TEXT } from 'constants/index';
import { FilePreviewProps } from 'interfaces';
import { StyledFilePreview } from 'styles/commonComponentStyle';

export const FilePreview: React.FC<FilePreviewProps> = ({ file, onRemove, loading }) => {
  return (
    <Fade in={!!file}>
      <StyledFilePreview>
        <FileIcon color="primary" />
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="body2" fontWeight="medium">
            {file.name}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {formatFileSize(file.size)} • {CSV_FILE_TEXT}
          </Typography>
        </Box>
        <IconButton
          onClick={onRemove}
          size="small"
          color="error"
          disabled={loading}
          aria-label={UPLOAD_TEXT.REMOVE_FILE}>
          <DeleteIcon />
        </IconButton>
      </StyledFilePreview>
    </Fade>
  );
};
